// extracted by mini-css-extract-plugin
export default {"wrapper":"PrivacyPolicy_wrapper__WhHu0","container":"PrivacyPolicy_container__IB23U","content":"PrivacyPolicy_content__fZOOc","subTitle":"PrivacyPolicy_subTitle__UG98z"};